<div class="main-wrapper">
    <div class="outer-wrapper">
        <div class="inner-section-mian payrol-main-wrapper">
            @if (isLoading) {
            <!-- Skeleton loading UI -->
            <div class="main-payrol-detail skeleton-main skeleton">
                <div class="payroll-subcomponent">
                    <div class="common-head">
                        <div class="skeleton-box title"></div>
                        <div class="skeleton-box button-group"></div>
                    </div>

                    <div class="table-container">
                        <div class="skeleton-table">
                            <div class="skeleton-row header"></div>
                            <div class="skeleton-row"></div>
                            <div class="skeleton-row"></div>
                            <div class="skeleton-row"></div>
                            <div class="skeleton-row"></div>
                            <div class="skeleton-row"></div>
                            <div class="skeleton-row"></div>
                            <div class="skeleton-row"></div>
                            <div class="skeleton-row"></div>
                            <div class="skeleton-row"></div>
                            <div class="skeleton-row"></div>
                            <div class="skeleton-row"></div>
                            <div class="skeleton-row"></div>
                            <div class="skeleton-row"></div>
                            <div class="skeleton-row"></div>
                            <div class="skeleton-row"></div>
                          
                        </div>
                    </div>
                </div>
            </div>
            } @else {
            <div class="main-payrol-detail">
                <div class="payroll-subcomponent">
                    <div class="common-head">
                        <div class="comon-left-head borderless">
                            <h1>Pay Roll</h1>
                        </div>
                        <div class="comon-right">

                            <div class="request-loan" (click)="loanreq()">
                                Request Loan
                            </div>
                        </div>
                    </div>

                    <div class="filter-section">
                        <h1>Filter</h1>
                        <div class="filter-fields">
                            <div class="form-group custom-select-wrapper">
                                <select class="form-control custom-select" [(ngModel)]="selectedMonth">
                                    <option value="" disabled selected hidden >Select Month</option>
                                     <option *ngFor="let month of months" [value]="month.value">{{ month.name }}</option>
                                </select>

                                <span class="custom-arrow">
                                    <i class="fa fa-chevron-down"></i>
                                </span>
                            </div>
                              <div class="form-group custom-select-wrapper">
                                <select class="form-control custom-select" [(ngModel)]="selectedYear">
                                    <option value="" disabled selected hidden>Select Year</option>
                                     <option *ngFor="let year of years" [value]="year">{{ year }}</option>
                                </select>

                                <span class="custom-arrow">
                                    <i class="fa fa-chevron-down"></i>
                                </span>
                            </div>
                            <button class="apply-filter" (click)="applyFilter()">Apply</button>
                        </div>
                    </div>

                    <div class="table-container">
                        <table class="responsive-table">
                            <thead>
                                <tr>
                                    <th>Year</th>
                                    <th>Month</th>
                                    <th>Realease Date</th>
                                    <th>Total</th>
                                    <th>Deduction</th>
                                    <th>Recieved</th>
                                    <th>Action</th>
                                </tr>
                            </thead>
                            <tbody>
                                 @for (item of salaries; track item.id) {
                                    <tr>
                                    <td>{{ item.month_year }}</td>
                                    <td>{{ item.month_char }}</td>
                                    <td>{{ item.salary_released_date | date:'dd-MM-yyyy' }}</td>

                                    <!-- Gross Salary -->
                                    <td>
                                        {{item.basic_salary === null ? "00" : item.basic_salary }}/- PKR
                                    </td>

                                    <!-- Tax -->
                                    <td>
                                     
                                        {{item.total_deduction === null ? "00" : item.total_deduction}}/- PKR
                                        
                                    </td>

                                    <!-- Net Salary -->
                                    <td>
                                   
                                        {{item.released_salary === null ? "00" : item.released_salary }}/- PKR
                                        
                                    </td>

                                    <td>
                                        <div class="active-button" (click)="showSlip(item)">
                                        <img src="../../../../assets/theme1/eye.png" alt="eye icon" />
                                        View
                                        </div>
                                    </td>
                                    </tr>
                                }
                            </tbody>
                        </table>
                    </div>


                </div>
            </div>
            }

        </div>
    </div>
</div>